import * as React from "react";

import "./order-details-sidebar-content.scss";

import {IsShowPricing}               from "@Common/logic/check-show-pricing";
import {isMasterVariation}           from "@Common/logic/item/is-master-variation";
import {cs}                          from "@Common/react/chain-services";
import {consumeContext}              from "@Common/react/context";
import {keyed}                       from "@Common/react/keyed";
import {Load2}                       from "@Common/react/load2";
import {UseState}                    from "@Common/react/use-state";
import {Types}                       from "@Common/types";
import {formatDate1, formatDateLong} from "@Common/ui-components/format-date";
import {InformationBadge}            from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {formatMoney}                 from "@Common/ui-components/language/format-money";
import {cascadeSum}                  from "@Common/utils/cascade";
import {chain}                       from "@Common/utils/fs";
import {
    isEmpty, isEmptyContainer,
    oMapToArr
}                                    from "@Common/utils/objects";

import {EnlargedView}           from "../../../../common/enlarged-view/enlarged-view";
import {LoadingPanel}           from "../../../../common/loading-panel/loading-panel";
import {SubsxFree}              from "../../../../common/subsx-free/subsx-free";
import {formatServiceLevelName} from "../../../../customize/steps/checkout/shipping-section/common/service-level/format-service-level-name";

import {KitDetails} from "./kit-details/kit-details";

type OrderDetails   = Types.Xpresso.Account.Orders.OrderDetailsSidebar.OrderDetails;

export const OrderDetailsSidebarContent = ({orderDetails: {comments, item, payments, displayOrderTotal=true, displayKitOptions=true}}:{
    orderDetails    : OrderDetails,
}) => cs(
    consumeContext("apis"),
    // consumeContext("themeScheme"),
    ["showPricing", (_, next) => IsShowPricing({next})],
    ["view", (_, next) => UseState({
        /*
            {boolean enlarged, integer key}
        */
        initValue: {enlarged: false, key: 0},
        next,
    })],
    ["enlargedView", ({view}, next) => EnlargedView({
        images: item?.proofUrls?.jpg || [{url: item.thumbnail}],
        onChangeView: (key) => view.onChange({...view.value, key: key}),
        viewing: view.value.key,
        next,
    })],
    ["facebookData", ({apis}, next) => Load2({
        fetch: async () => item.metaData?.fbAds && await apis.next.social.getFacebookAdsStats({itemId: item.itemId}),
        next,
    })],
    ({showPricing, enlargedView, facebookData}) => (
        <div className="order-details-sidebar-content-u3e">
            {/*<GlobalKeys {...{*/}
            {/*    keyCombo: "Escape",*/}
            {/*    onKeyDown: close,*/}
            {/*}} />*/}
            <div className="header">
                <div className="left">
                    <div className="order-id" xd-qa-type="label" xd-qa-name={"Order ID"}>
                        Order ID {item.itemId}
                    </div>
                    {item.orderDate && (
                        <div className="date" xd-qa-type="label" xd-qa-name={"Date"}>
                            {formatDateLong(new Date(item.orderDate.date))}
                        </div>
                    )}
                </div>
                {/*<div className="right">*/}
                {/*    <button*/}
                {/*        className="close-btn"*/}
                {/*        xd-qa-type="icon"*/}
                {/*        xd-qa-name={"Close" + item.itemId}*/}
                {/*        onClick={() => {*/}
                {/*            close();*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        <span className="fa-layers fa-fw">*/}
                {/*            <FontAwesomeIcon className="icon1" icon={faSlash} color={themeScheme.xpresso.menuTextColor} flip={"horizontal"}/>*/}
                {/*            <FontAwesomeIcon className="icon2" icon={faSlash} color={themeScheme.xpresso.menuTextColor}/>*/}
                {/*        </span>*/}
                {/*    </button>*/}
                {/*</div>*/}
            </div>
            <div className="long-divider"/>
            <div className="middle">
                <div className="header-line">
                    <div className="description" xd-qa-type="label" xd-qa-name={"Description"}>
                        DESCRIPTION
                    </div>
                    <div className="qty" xd-qa-type="label" xd-qa-name={"QTY"}>
                        QTY
                    </div>
                    {showPricing && <div className="price" xd-qa-type="label" xd-qa-name={"Label Item Price"}>
                        PRICE
                    </div>}
                </div>
                <div className="divider"/>
                <div className="thumbnail-line">
                    <div className="thumbnail" xd-qa-type="icon" xd-qa-name={"Preview"}>
                        {item.thumbnail ? (
                            <img src={item.thumbnail} alt={item.itemName} onClick={() => enlargedView.show()}/>
                        ) : (
                            <img src={require("../../../../../../public/assets/NoImageAvailable.png")} alt="No Image Available"/>
                        )}
                    </div>
                    <div className="middle">
                        <div className="name" xd-qa-type="label" xd-qa-name={"Name"}>
                            {item.itemName}
                        </div>
                    </div>
                    <div className="qty" xd-qa-type="label" xd-qa-name={"Item Quantity"}>
                        {item.selections.quantity}
                    </div>
                    {showPricing && <div className="right">
                        <div className="price" xd-qa-type="label" xd-qa-name={"Item Price"}>
                            {item.isFlatRate ? (
                                formatMoney(item.selections.unitPrice, {useFreeLabel:false, alwaysShowDollarSymbol:true})
                            ) : (
                                formatMoney(item.selections.unitPrice * (item.selections.quantity), {useFreeLabel:false, alwaysShowDollarSymbol:true})
                            )}
                        </div>
                        <div className="each" xd-qa-type="label" xd-qa-name="Price Type">
                            {item.metaData?.fbAds ? '' : item.isFlatRate ? (
                                item.selections.unitPrice > 0 && 'Flat Rate'
                            ) : (
                                item.selections.unitPrice > 0 && formatMoney(item.selections.unitPrice, {useFreeLabel:false, alwaysShowDollarSymbol:true}) + 'ea'
                            )}
                        </div>
                    </div>}
                </div>
                { <>
                    <div className="sub-divider"/>
                    <div className="line-content">
                        <div className="line-row">
                            <div className="product" xd-qa-type="label">Product</div> 
                            <div className="productValue" xd-qa-type="label" xd-qa-name={"Product"}>
                                {item.product}
                            </div> 
                        </div>
                        <div className="line-row">
                            <div className="product" xd-qa-type="label">Template</div>
                            <div className="productValue" xd-qa-type="label" xd-qa-name={"TemplateName"}>
                                {item.metaData?.templateName}
                            </div> 
                        </div> 
                        {
                            ( item.finishedSize ) && <>
                            <div className="line-row">   
                                <div className="product" xd-qa-type="label">Finished Size</div>
                                <div className="productValue" xd-qa-type="label" xd-qa-name={"FinishedSize"}>
                                    {item.finishedSize}
                                </div>
                            </div>
                            </>
                        }
                    </div>
                    </>
                }
                {
                    (item.campaignAnalyticsDashboardUrl ) && <>
                        <div className="sub-divider"/>
                        <div className="line-padding"> 
                        <div className="line" xd-qa-type="label" xd-qa-name={"Campaign Insights"}>                           
                          Keep track of your listing's orders and share the performance results via
                                <a
                                className="link"
                                target="_blank"
                                xd-qa-type="link"
                                href={(item.campaignAnalyticsDashboardUrl)}
                                >                                
                                    &nbsp; Campaign Insights                               
                                </a>   
                            </div>                           
                        </div>
                    </>
                }
                {(item?.selections?.mailingListIds?.length > 0 ) && <>
                    <div className="sub-divider"/>
                    {(item.sampleShippingAddressId > 0 && item.sampleAddress) && <>
                        <div className="line-padding">
                            <div className="line" xd-qa-type="label" xd-qa-name={"Sample Address Label"}><b>Sample Address</b></div>
                            {item.sampleAddress.name && <div className="line" xd-qa-type="label" xd-qa-name={"Sample Name 1"}>{item.sampleAddress.name}</div>}
                            {item.sampleAddress.name2 && <div className="line" xd-qa-type="label" xd-qa-name={"Sample Name 2"}>{item.sampleAddress.name2}</div>}
                            <div className="line" xd-qa-type="label" xd-qa-name={"Sample Address"}>{item.sampleAddress.address}</div>
                            {item.sampleAddress.address2 && <div className="line" xd-qa-type="label" xd-qa-name={"Sample Address 2"}>{item.sampleAddress.address2}</div>}
                            <div className="line" xd-qa-type="label" xd-qa-name={"Sample City State Zip"}>
                                {item.sampleAddress.city}
                                {item.sampleAddress.state && ", " + item.sampleAddress.state}
                                {item.sampleAddress.zip && " " + item.sampleAddress.zip}
                            </div>
                        </div>
                    </>}
                    <div className="mailing-lists">
                        {['mailing', 'mail'].includes(item.selections.distributionType) && (
                            <div className="line" xd-qa-type="text" xd-qa-name={item.distributionMethod?.toLowerCase().includes("first") ? "First Class Mailing" : "Standard Mailing"}>
                                <b>{item.distributionMethod?.toLowerCase().includes("first") ? "First Class Mailing" :
                                (!!(item?.metaData?.template?.isNDM) ? "Neighborhood Direct Mail" : "Standard Mailing")}</b>
                            </div>
                        )}
                        {item?.selections?.mailingListIds?.length > 0 && <div className="line" xd-qa-type="label" xd-qa-name={"Address Lists Selected"}><b>Address Lists Selected:</b></div>}
                        {item.selections.mailingListIds.map((mailingList, i) => cs(
                            keyed(i),
                            () => (
                                <div className="mailing-list-line">
                                    <div className="description" xd-qa-type="label" xd-qa-name={mailingList.name + " Mailing List Name"}>
                                        {mailingList.name}
                                        {!item.metaData?.fbAds &&
                                            mailingList.unitPrice > 0 &&
                                            showPricing &&
                                            (mailingList.requirePurchase || mailingList.typeId == 6) &&
                                            !item.distributionMethod?.toLowerCase().includes("ndm") &&
                                            " @ " + formatMoney(mailingList.unitPrice, {useFreeLabel:false, alwaysShowDollarSymbol:true}) + 'ea'}
                                    </div>
                                    <div className="qty" xd-qa-type="label" xd-qa-name={mailingList.name + " Mailing Quantity"}>
                                        {mailingList.quantity}
                                    </div>
                                    {showPricing && (
                                        mailingList.hasSubscriptionBenefit ? (
                                            <div className="subsx-free">
                                                {SubsxFree({
                                                    xdQaName:mailingList.name + " Subsx Mailing Charge"
                                                })}
                                            </div>
                                        ) : (
                                            <div className="price" xd-qa-type="label" xd-qa-name={"Maiing Price"}>
                                                {(mailingList.requirePurchase || mailingList.typeId == 6) &&
                                                !item.distributionMethod?.toLowerCase().includes("ndm") &&
                                                (['mailing', 'mail'].includes(item.selections.distributionType) || (!['mailing', 'mail'].includes(item.selections.distributionType) && mailingList.unitPrice > 0)) &&
                                                formatMoney(mailingList.unitPrice * mailingList.quantity, {useFreeLabel:false, alwaysShowDollarSymbol:true})}
                                            </div>
                                        )
                                    )}
                                </div>
                            ),
                        ))}
                        {item?.displaySampleAddress &&
                            <div className="mailing-list-line">
                                <div className="description" xd-qa-type="label" xd-qa-name={"Sample Card"}>
                                    +1 Sample Card
                                </div>
                            </div>
                        }
                        {item.blankQty > 0 && <div className="mailing-list-line">
                            <div className="description" xd-qa-type="label" xd-qa-name={"Non addressed Quantity"}>
                                Non-addressed quantity
                            </div>
                            <div className="qty" xd-qa-type="label" xd-qa-name={"Non address Quantity"}>
                                {item.blankQty}
                            </div>
                            {showPricing && <div className="price" xd-qa-type="label" xd-qa-name={"Non address Price"}>
                                {formatMoney(0, {useFreeLabel:false, alwaysShowDollarSymbol:true})}
                            </div>}
                        </div>}
                    </div>
                </>}
                {item?.selections?.options?.map((option, i) => cs(
                    keyed(i),
                    () => (
                        (
                            (option.isUi === undefined || option.isUi) && //support orders that preceed isUi flag
                            option.name !== 'Barcode Printing' &&
                            option.dev_key !== 'paper_type' &&
                            option.dev_key !== 'coating_type' &&
                            option.dev_key !== 'pick_pack_options' &&
                            option.dev_key !== "okay_to_mail_early" &&
                            true
                        ) ? <>
                            <div className="sub-divider"/>
                            <div className="line-item">
                                <div className="description" xd-qa-type="label" xd-qa-name={"Item Description " + option.name}>
                                    {option.group === 'Finishing' && option.subGroup && option.subGroup + ' '}
                                    {option.name}
                                    {!item.metaData?.fbAds && option.unitPrice > 0 && showPricing && " @ " + formatMoney(option.unitPrice, {useFreeLabel:false, alwaysShowDollarSymbol:true}) + 'ea'}
                                </div>
                                {option.unitPrice > 0 && <div className="qty" xd-qa-type="label" xd-qa-name={option.name + " Quantity"}>
                                    {option.dev_key === 'expedited_production'? 1 : item.selections.quantity}
                                </div>}
                                {showPricing && <div className="price" xd-qa-type="label" xd-qa-name={option.name + " Price"}>
                                    {option.unitPrice > 0 ? (
                                        formatMoney(option.unitPrice * (
                                                    option.dev_key === 'expedited_production'? 1 : item.selections.quantity
                                                ), {useFreeLabel:false, alwaysShowDollarSymbol:true}
                                            )
                                    ) : option.flatPrice > 0 ? (
                                        formatMoney(option.flatPrice, {useFreeLabel:false, alwaysShowDollarSymbol:true})
                                    ) : (
                                        formatMoney(0, {useFreeLabel:false, alwaysShowDollarSymbol:true})
                                    )}
                                </div>}
                            </div>
                        </> : option.dev_key === 'pick_pack_options' && !isEmpty(JSON.parse(option.name)) && <>
                            <div className="sub-divider"/>
                            <div className="line-padding">
                                <div className="line" xd-qa-type="label" xd-qa-name="PickPack Options">
                                    <b>PickPack Options</b>
                                </div>
                                {isMasterVariation(item) ? (
                                    oMapToArr(JSON.parse(option.name).filter((o) => o.type === "options"), (value) => {
                                        const label = value.uiLabel + ": " + value.uiValue;
                                        return <div className="line" xd-qa-type="text" xd-qa-name={label}>{label}</div>
                                    })
                                ) : (
                                    oMapToArr(JSON.parse(option.name),(value, key:string) => (
                                        <div className="line" xd-qa-type="text" xd-qa-name={key + ": " + value}>
                                            {key + ": " + value}
                                        </div>
                                    ))
                                )}
                            </div>
                        </>
                    )
                ))}
                {item.metaData?.fbAds && facebookData.loading ? <>
                <div className="white-space">
                    {LoadingPanel({})}
                </div>
                </> : item.metaData?.fbAds && facebookData.value[0] ?  <>
                    <div className="sub-divider"/>
                    <div className="line-padding">
                        <div className="line" xd-qa-type="label" xd-qa-name={"Facebook Ad"}><b>Facebook Ad</b></div>
                        <div className="line" xd-qa-type="text" xd-qa-name={"Price for each day"}>
                            {item.selections.unitPrice > 0 && "@ " + formatMoney(item.selections.unitPrice, {useFreeLabel:false, alwaysShowDollarSymbol:true}) + " for each day"}
                        </div>
                        <br/>
                        <div className="line" xd-qa-type="text" xd-qa-name={"Dates"}>Stats for: {(facebookData.value[0].date_start).split(" ")[0]}
                            {
                                (facebookData.value[0].date_start).split(" ")[0] !== (facebookData.value[0].date_stop).split(" ")[0]
                                 ? ` through ${(facebookData.value[0].date_stop).split(" ")[0]}`
                                 : null
                            }
                        </div>
                        <div className="line" xd-qa-type="text" xd-qa-name={"Clicks"}>Clicks: {facebookData.value[0].clicks}</div>
                        <div className="line" xd-qa-type="text" xd-qa-name={"Impressions"}>Impressions: {facebookData.value[0].impressions}</div>
                        <div className="line" xd-qa-type="text" xd-qa-name={"Clickthrough rate"}>Clickthrough rate: {facebookData.value[0].ctr}%</div>
                    </div>
                </> : item?.selections?.distributionType === "download" && <>
                    <div className="sub-divider"/>
                    <div className="line-padding">
                        <div className="line" xd-qa-type="label" xd-qa-name={"Digital Download"}><b>Digital Download</b></div>
                    </div>
                </>}
                {new Date(item?.scheduledDate?.date).getTime() > new Date().getTime() && <>
                    <div className="sub-divider"/>
                    <div className="shipping-message" xd-qa-type="label" xd-qa-name={"Shipping Message"}>
                        Scheduled Fulfillment: {" "}{formatDate1(new Date(item.scheduledDate.date))}
                    </div>
                </>}
                {item.shipping && (item.shipping.shippingAddress || item.shipping.estimatedDeliveryMessage) && <>
                    <div className="sub-divider"/>
                    {item.shipping.shippingAddress && <div className="line-padding">
                        <div className="line" xd-qa-type="label" xd-qa-name={"Shipping Address"}><b>Shipping Address</b></div>
                        {item.shipping.shippingAddress.contactName && <div className="line" xd-qa-type="label" xd-qa-name={"Shipping Contact Name"}>{item.shipping.shippingAddress.contactName}</div>}
                        {item.shipping.shippingAddress.company && item.shipping.shippingAddress.company !== 'POSTCARDMANIA' &&
                            <div className="line" xd-qa-type="label" xd-qa-name={"Shipping Company"}>{item.shipping.shippingAddress.company}</div>
                        }
                        <div className="line" xd-qa-type="label" xd-qa-name={"Shipping Address 1"}>{item.shipping.shippingAddress.address1}</div>
                        {item.shipping.shippingAddress.address2 && <div className="line" xd-qa-type="label" xd-qa-name={"Shipping Address 2"}>{item.shipping.shippingAddress.address2}</div>}
                        <div className="line" xd-qa-type="label" xd-qa-name={"Shipping City State Zip"}>
                            {item.shipping.shippingAddress.city}
                            {item.shipping.shippingAddress.state && ", " + item.shipping.shippingAddress.state}
                            {item.shipping.shippingAddress.postalCode && " " + item.shipping.shippingAddress.postalCode}
                        </div>
                        {item.shipping.shippingAddress.countryCode && <div className="line" xd-qa-type="label" xd-qa-name={"Shipping Country"}>{item.shipping.shippingAddress.countryCode}</div>}
                        {item.shipping.shippingAddress.contactPhone && <div className="line" xd-qa-type="label" xd-qa-name={"Shipping Phone"}>{item.shipping.shippingAddress.contactPhone}</div>}
                    </div>}
                    {item.shipping.estimatedDeliveryMessage && <div className="sub-divider"/> }
                    {item.shipping.estimatedDeliveryMessage && <div className="shipping-message" xd-qa-type="label" xd-qa-name={"Estimated Arrival"}>
                        Estimated Arrival: {" "}{item.shipping.estimatedDeliveryMessage}
                    </div>}
                </>}
                {item?.pickupAddress && <>
                    <div className="sub-divider"/>
                    <div className="line-padding">
                        <div className="line" xd-qa-type="label" xd-qa-name={"Pickup Address"}><b>Pickup Address</b></div>
                        <div className="line" xd-qa-type="label" xd-qa-name={"Pickup Company"}>{item.pickupAddress.company}</div>
                        <div className="line" xd-qa-type="label" xd-qa-name={"Pickup Address 1"}>{item.pickupAddress.address1}</div>
                        <div className="line" xd-qa-type="label" xd-qa-name={"Pickup Address 2"}>{item.pickupAddress.address2}</div>
                        <div className="line" xd-qa-type="label" xd-qa-name={"Pickup Phone"}>{item.pickupAddress.contactPhone}</div>
                    </div>
                </>}
            </div>
            {
                !isEmptyContainer(item.components) &&
                Object.values(item.components).filter(component => component?.selections?.quantity > 0).length > 0 &&
                KitDetails({item, displayKitOptions})
            }
            <div className="bottom">
                <div className="grey-box">
                    {item.itemTotals?.map((itemTotal, i) => cs(
                        keyed(i),
                        () => <>
                            {itemTotal.type !== 'subTotal' && <div className="sub-divider"/>}
                            <div className="line-item">
                                {itemTotal.type !== 'subTotal' && <div className="sub-divider"/>}
                                {itemTotal.type === 'shippingCharge' ? (<>
                                    <div className="description" xd-qa-type="label" xd-qa-name={item.shipping?.serviceLevelUpgraded? 'FedEx 2 Day': item.shipping.serviceLevel}>
                                        {chain(
                                            item.shipping?.serviceLevelUpgraded? 'FedEx 2 Day': item.shipping.serviceLevel,
                                            (_) => _ ? formatServiceLevelName(_) : "..."
                                        )}
                                        {item.shipping?.serviceLevelUpgraded && (
                                            <div className="line" xd-qa-type="label" xd-qa-name={"Shipping Service Upgrade"}>
                                                Shipping Service Level has been upgraded at no additional cost
                                            </div>
                                        )}
                                    </div>
                                    {showPricing && <div className="price" xd-qa-type="label" xd-qa-name={"Shipping Price"}>
                                        {formatMoney(item.shipping.shippingCharge, {freeLabel:"Free Shipping!"})}
                                    </div>}
                                    </>) :
                                    (itemTotal.type === 'rdf'?
                                        (<>
                                            <div className="description" xd-qa-type="label" xd-qa-name={itemTotal.name}>
                                                {itemTotal.name}
                                                <span style={{marginLeft: "5px"}}>
                                                    {InformationBadge({
                                                        getTooltip: () => itemTotal.description,
                                                        direction: "south-west",
                                                        xdQaName: "RDF",
                                                    })}
                                                </span>
                                            </div>
                                            {showPricing && <div className="price" xd-qa-type="label" xd-qa-name={`${itemTotal.name} Amount`}>
                                                {formatMoney(itemTotal.amount, {useFreeLabel:false, alwaysShowDollarSymbol:true})}
                                            </div>}
                                        </>) :
                                        (itemTotal.type === 'vatTax' ?
                                            (<>
                                                <div className="description" xd-qa-type="label" xd-qa-name="VAT Tax">
                                                    {itemTotal.name}
                                                    <span style={{marginLeft: "5px"}}>
                                                        {InformationBadge({
                                                            getTooltip: () => "For your convenience, duties and taxes required for customs clearance are collected at checkout",
                                                            xdQaName: "VAT",
                                                        })}
                                                    </span>
                                                </div>
                                                {showPricing && <div className="price" xd-qa-type="label" xd-qa-name={`${itemTotal.name} Amount`}>
                                                    {formatMoney(itemTotal.amount, {useFreeLabel:false, alwaysShowDollarSymbol:true})}
                                                </div>}
                                        </>) :
                                        (<>
                                            <div className="description" xd-qa-type="label" xd-qa-name={itemTotal.name}>
                                                {itemTotal.type === "promoCode" ?  `Promo Code Discount${itemTotal.message && ' (' + itemTotal.message + ')'}` : itemTotal.name}
                                            </div>
                                            {showPricing && <div className="price" xd-qa-type="label" xd-qa-name={`${itemTotal.name} Amount`}>
                                                {formatMoney((itemTotal.type !== "promoCode" ? 1 : -1) * itemTotal.amount, {useFreeLabel:false, alwaysShowDollarSymbol:true})}
                                            </div>}
                                        </>)
                                    ))
                                }
                            </div>
                        </>
                    ))}
                    {displayOrderTotal && <>
                        <div className="divider"/>
                        <div className="line-item">
                            <div className="description" xd-qa-type="label" xd-qa-name={"Total"}>
                                <b>Total</b>
                            </div>
                            {showPricing && (
                                <div className="price" xd-qa-type="label" xd-qa-name={"Total Price"}>
                                    {formatMoney(
                                        cascadeSum(item, "itemTotals[*].amount", (amount,{},{1:p}) => (p.type !== "promoCode" ? 1 : -1) * amount),
                                        {useFreeLabel:false, alwaysShowDollarSymbol:true}
                                    )}
                                </div>
                            )}
                        </div>
                    </>}
                    {payments?.map((payment:Types.Apis.Models.OrderDetails['payments'][number], i) => cs(
                        keyed(i),
                        () => <>
                            <div className="sub-divider"/>
                            <div className="payment-line-item">
                                <div className="payment-description" xd-qa-type="label" xd-qa-name={payment.type + " Payment Description"}>
                                    <div className="type" xd-qa-type="label" xd-qa-name={payment.type + " Payment Type"}>
                                        {payment.type}
                                    </div>
                                    {payment.label && <div className="label" xd-qa-type="label" xd-qa-name={payment.type + " Payment Label"}>
                                        {payment.label}
                                    </div>}
                                </div>
                                {showPricing && (
                                    <div className="price" xd-qa-type="label" xd-qa-name={payment.type + " Payment"}>
                                        {'-' + formatMoney(payment.value, {useFreeLabel:false, alwaysShowDollarSymbol:true})}
                                    </div>
                                )}
                            </div>
                            {payment?.meta1Label && (<>
                                <div className="sub-divider"/>
                                <div className="line-item">
                                    <div className="description" xd-qa-type="label" xd-qa-name={payment.type + " Meta Description 1"}>
                                        {payment.meta1Label}
                                    </div>
                                    <div className="price" xd-qa-type="label" xd-qa-name={payment.type + " Meta Price 1"}>
                                        {payment.meta1Value}
                                    </div>
                                </div>
                            </>)}
                            {payment?.meta2Label && (<>
                                <div className="sub-divider"/>
                                <div className="line-item">
                                    <div className="description" xd-qa-type="label" xd-qa-name={payment.type + " Meta Description 2"}>
                                        {payment.meta2Label}
                                    </div>
                                    <div className="price" xd-qa-type="label" xd-qa-name={payment.type + " Meta Price 2"}>
                                        {payment.meta2Value}
                                    </div>
                                </div>
                            </>)}
                            {payment?.comments && (<>
                                <div className="sub-divider"/>
                                <div className="line-item">
                                    <div className="description" xd-qa-type="text" xd-qa-name={payment.type + ' ' + payment.comments }>
                                        Comments: {payment.comments.replace("some text no one will ever read", "")}
                                    </div>
                                </div>
                            </>)}
                        </>,
                    ))}
                </div>
            </div>
            {comments?.billing && (
                <div className="bottom">
                    <div className="grey-box">
                        <div xd-qa-type="label" xd-qa-name={"Billing Comments"}><b>Billing Comments: </b></div>
                        <div xd-qa-type="text" xd-qa-name={comments.billing}>{comments.billing}</div>
                    </div>
                </div>
            )}
            {comments?.adBudget && (
                <div className="bottom">
                    <div className="grey-box">
                        <div xd-qa-type="label" xd-qa-name={"Ad Budget Comments"}><b>Ad Budget Comments: </b></div>
                        <div xd-qa-type="text" xd-qa-name={"Ad Budget Comment"}>{comments.adBudget.replace("some text no one will ever read", "")}</div>
                    </div>
                </div>
            )}

        </div>
    ),
);

